<script setup>
import AcknowledgementModal from "@/components/kit/AcknowledgementModal.vue";
import useKit from "@/composables/useKit";
import {ref} from "vue";
import KitHelpModal from "@/components/kit/KitHelpModal.vue";

const {isSubscribedToKit} = useKit();

const emit = defineEmits(['close']);

const showConfirmModal = ref(true);

const handleContinue = () => {
  emit('close');
};

const handleShowHelpModal = () => {
  showConfirmModal.value = false;
};

const handleHelpClose = () => {
  emit('close');
}

</script>

<template>
  <AcknowledgementModal
    v-if="showConfirmModal && isSubscribedToKit"
    heading="Changing lots of keywords? Chat with one of my managers 💬"
    confirm-text="No, I’m happy with the keywords"
    cancel-text="Yes, contact an account manager"
    @close="handleShowHelpModal"
    @dismiss="handleContinue"
    @confirm="handleContinue"
  >
    <p>
      The keywords I chose were carefully based on the information you’ve provided, such as your main products/services, locations and competitors.
    </p>
    <p>
      If you're not 100% confident in what’s been selected, I recommend <strong>speaking with one of our account managers first</strong>—they're here to help fine-tune things without throwing your progress off track.
    </p>
  </AcknowledgementModal>
  <KitHelpModal
    v-if="!showConfirmModal && isSubscribedToKit"
    screen="keywords"
    @close="handleHelpClose"
  />
</template>